import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserDisplayInfo } from '../../../../models/UserDisplayInfo';
import { DataService } from '../../../../services/data.service';
import { Router } from '@angular/router';
import { VendorService } from '../../../../services/vendor.service';
import { VendorInfo } from '../../../../models/VendorInfo';

@Component({
  selector: 'app-vendor-contact',
  templateUrl: './vendor-contact.component.html',
  styleUrls: ['./vendor-contact.component.scss']
})
export class VendorContactComponent implements OnInit, OnDestroy {
  contacts: VendorInfo[];
  GPVID: string;
  public errorMsg: string;
  public showFailConfirmation = false;
  public rowsOnPage = 20;
  public sortBy = '';
  public sortOrder = 'asc';
  public showRowDetails: number;
  private alive = true;
  constructor(private dataSvc: DataService,
  private vendorSvc: VendorService,
  private router: Router) {
    this.GPVID = this.dataSvc.userDisplayInfo.GPVID;
  }

  ngOnInit() {
    this.contacts = [];
    this.getContacts();
  }

  onUpdate(item: VendorInfo) {
    this.router.navigate([`/pages/vendor/myvendor/vendorcontacts/updatecontact`],
      {
        queryParams: {
          GPVID: item.GPVID,
          addressCode: item.AddressCode
        }
      });
  }

  getContacts() {
    this.vendorSvc.getVendorContacts(this.GPVID)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.errorMsg = null;
        this.showFailConfirmation = false;
        console.log(data);
        this.contacts = data;
      },
      error => {
        this.showFailConfirmation = true;
        this.errorMsg = error;
      }
    );
  }

  close() {
    this.showFailConfirmation = false;
  }

  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/vendor-contact/vendor-contact.component.ts